import React, { useState, useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import api from '../../api/api';
import './CalendarBanner.css';

const CalendarBanner = ({ user, onSuccess }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (user && !user.calendarEventId) {
      const lastDismissed = localStorage.getItem('calendarBannerDismissed');
      const now = Date.now();
      
      // If never dismissed OR dismissed more than 3 days ago (3 * 24 * 60 * 60 * 1000)
      if (!lastDismissed || (now - parseInt(lastDismissed)) > 3 * 24 * 60 * 60 * 1000) {
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  }, [user]);

  const handleDismiss = () => {
    localStorage.setItem('calendarBannerDismissed', Date.now().toString());
    setIsVisible(false);
  };

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        await api.post('/auth/google/sync-calendar', { code: codeResponse.code });
        onSuccess(); // Refresh user data
        setIsVisible(false);
      } catch (err) {
        console.error('Calendar sync failed', err);
      }
    },
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/calendar.events',
  });

  if (!isVisible) return null;

  return (
    <div className="calendar-banner">
      <div className="calendar-banner-content">
        <div className="calendar-banner-icon">🗓️</div>
        <div className="calendar-banner-text">
          <h4>Don't lose your streak!</h4>
          <p>Schedule a daily study reminder on your Google Calendar to stay consistent.</p>
        </div>
      </div>
      <div className="calendar-banner-actions">
        <button className="calendar-sync-btn" onClick={() => login()}>
          Sync Calendar
        </button>
        <button className="calendar-dismiss-btn" onClick={handleDismiss}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default CalendarBanner;
